import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";


import { AuthProvider } from "./config/AuthContext";
import MainRoutes from "./routes/MainRoute";
import { registerDeployUpdateCheck } from "./utils/deployUpdateCheck";

import "./App.css";
import { ErrorBoundaryWrapper } from "./components/ErrorBoundary";

function App() {
    useEffect(() => registerDeployUpdateCheck(), []);

    return (
        <AuthProvider>
            <ThemeProvider>
                <LanguageProvider>
                    <div className="App">
                        <BrowserRouter>
                            <ErrorBoundaryWrapper>
                                <MainRoutes />
                            </ErrorBoundaryWrapper>
                        </BrowserRouter>
                        <Toaster position="top-right" richColors />
                    </div>
                </LanguageProvider>
            </ThemeProvider>
        </AuthProvider>
    );
}

export default App;